import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Subject, Subscription } from 'rxjs';
import { ReportPageInterface } from 'src/app/interface';
import { Order, Report } from 'src/app/model';
import { FinalStatus, FooterButtonOption, PageNumbers, ReportState, TransactionType } from 'src/app/model/Enums';
import { CurrencyPipe } from 'src/app/pipes';
import { ReportProvider } from 'src/app/providers';
import { LoaderService, ReportService, UserService, ToasterService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { ExternalAnswerPopupComponent } from '..';
import { OrderFormConfirmPopupComponent } from '../../dashboard/components';
import { PaymentPopupComponent } from '../index';
import { saveAs } from 'file-saver';
import { SpendCreditPopupComponent } from '../components/payment/spend-credit-popup/spend-credit-popup.component';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import {ReportCopyVersionPopupComponent} from '../../../components';
import {ViewReportModalComponent} from '../../../modals/view-report-modal/view-report-modal.component';
import {animate, animation, style, transition, trigger} from '@angular/animations';


@Component({
  selector: 'app-conclusion',
  templateUrl: './conclusion.component.html',
  styleUrls: ['./conclusion.component.scss'],
  animations: [
    trigger('enterLeaveAnimation', [
      transition(':enter', [
        style({opacity: 0, transform: 'scale(0.8)'}),
        animate('500ms ease-in', style({opacity: 1, transform: 'scale(1)'}))
      ]),
      /*transition(':leave', [
        style({opacity: 1, transform: 'scale(1)'}),
        animate('500ms ease-in', style({opacity: 0, transform: 'scale(0.8)'}))
      ])*/
    ])
  ]
})
export class ConclusionComponent implements OnInit, OnDestroy, ReportPageInterface {
  isLoading: boolean = true;
  validatingReport: boolean = true;
  calculatingFinalValue: boolean = false;
  marketValue: number = 0;

  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  errorMessage: string = '';

  showCustomDebug: boolean = false;
  debugInformation: string[] = [];

  calculationVisible: boolean = true;
  isPaid: boolean = true;
  subscribeParams: Subscription;
  invalidPageList: Array<any> = [];

  isBlur: boolean = true;

  valueApproach: string = '';
  ReportState = ReportState;
  isDebtRefinance: boolean = false;
  promo: string = '';

  conclusionSub: Subscription;

  constructor(public reportService: ReportService,
    private reportProvider: ReportProvider,
    private modalService: BsModalService,
    public userService: UserService,
    private router: Router,
    public currencyPipe: CurrencyPipe,
    private toastr: ToasterService,
    private loaderService: LoaderService,
  ) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport && this.currentReport.LATEST) {
        this.isDebtRefinance = this.currentReport.LATEST.COMPANY.TRANSACTION_TYPE == TransactionType.REFINANCING;
        this.reportService.updateMaxStage(PageNumbers.CONCLUSION);
        this.validateReport();
      }
    });

    this.conclusionSub = this.reportService.updateConclusionPage.subscribe(() => {
      this.isLoading = true;
      this.validateReport();
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub) {
      this.reportSub.unsubscribe();
    }
    if (this.subscribeParams) {
      this.subscribeParams.unsubscribe();
    }
    if (this.conclusionSub) {
      this.conclusionSub.unsubscribe();
    }
  }

  /**
   * @description validate report
   */
  validateReport() {
    this.validatingReport = true;
    this.reportProvider.validateFullReport(this.currentReport.LATEST.ID).subscribe(resp => {
      if (resp.success && resp.result && resp.result.length && !resp.result.some(el => el.STATE === 'INVALID')) {
        this.getFinalValue();
      } else {
        if (resp.result && resp.result.length) {
          resp.result.forEach(element => {
            if (element.STATE === 'INVALID') {
              element.pageId = ReportPageConstant[element.PAGE];
              this.invalidPageList.push(element);
            }
          });
        }
        this.isLoading = false;
        this.calculationVisible = false;
      }
      this.validatingReport = false;
    }, err => {
      this.validatingReport = false;
      // Error Handling
    });
  }

  /**
   * @description for get final values
   */
  getFinalValue() {
    this.calculatingFinalValue = true;
    this.reportProvider.calculateFinalValue(this.currentReport.LATEST.ID).subscribe(resp => {
      if (resp.success) {
        const result = resp.result;
        if(result?.PROMO_CODE){
          this.promo = result.PROMO_CODE;
        }else{
          this.promo = '';
        }
        if (this.currentReport.CREATED_BY.ID == this.userService.getUserId() && (result.STATUS == FinalStatus.NO_CREDITS || result.STATUS == FinalStatus.NEED_UNLOCKING)) {
          this.openPaymentPopup(false);
        } else if (result.STATUS == FinalStatus.OK) {
          const resultData = result.DATA;
          this.calculationVisible = true;
          this.valueApproach = this.reportService.changeTextStyle(resultData.VALUE_APPROACH);
          this.marketValue = Number(resultData[resultData.VALUE_APPROACH]);
          this.debugInformation = resultData.DEBUG_INFO;
          this.isBlur = false;

          // if org user and org type is bank -> check state non billable
          if (this.userService.isOrganizationType_BANK() && this.currentReport.STATE != ReportState.NON_BILLABLE) {
            this.reportService.getUpdatedStatusOfReport();
          }
        }
      } else {
        this.errorMessage = resp.error.txt;
      }
      this.isLoading = false;
      this.calculatingFinalValue = false;
    }, err => {
      this.calculatingFinalValue = false;
      // Error Handling
    });
  }

  /**
   * @description request for external question
   */
  requestExternal() {
    let confirmModalRef: BsModalRef;
    confirmModalRef = this.modalService.show(ExternalAnswerPopupComponent, Object.assign({
      initialState: {
        message: ''
      }
    }, { class: 'modal-lg' }));

    const ackSubject = new Subject<boolean>();
    confirmModalRef.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        // blank
      }
    });
  }

  /**
   * @description for goto particular page
   * @param pageLink next page link
   */
  gotoPage(pageLink: string) {
    this.router.navigateByUrl(`/report/${this.currentReport.ID}/${pageLink}`);
  }

  /**
   * @description for open custom debug window
   * @param $event keyboard event
   */
  @HostListener('window:keydown', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if (environment.SHOW_DEBUG && ($event.ctrlKey || $event.metaKey) && ($event.keyCode == 68 || $event.keyCode == 81) && this.debugInformation.length) {
      this.showCustomDebug = !this.showCustomDebug;
    }
  }

  /**
   * @description for open payment popup
   */
  openPaymentPopup(forUnlock: boolean) {
    this.modalService.show(PaymentPopupComponent, Object.assign({
      initialState: {
        reportId: this.currentReport.ID,
        isFromUnlock: forUnlock,
        basePrice: this.currentReport.BASE_PRICE,
        promo: this.promo
      }
    }, { class: 'modal-dialog-centered payment__popup' }));
  }

  /**
   * @description open spend cridit points
   */
  openSpendCreditPopup() {
    let spendCreditModalRef: BsModalRef;
    spendCreditModalRef = this.modalService.show(SpendCreditPopupComponent, Object.assign({}, { class: 'modal-dialog-centered spend__credit__popup' }));
    const ackSubject = new Subject<boolean>();
    spendCreditModalRef.content.subject = ackSubject;

    ackSubject.subscribe(result => {
      if (result) {
        this.reportProvider.spendCredit(this.currentReport.ID).subscribe(resp => {
          if (resp.success) {
            this.getFinalValue();
            this.reportService.getUpdatedStatusOfReport();
          }
        });
      }
    });
  }

  /**
   * @description for download report
   */
  downloadReportPDF(isOrderThirdParty: boolean = false) {
    const loadingObj = {
      loading: true,
      loadingMessage: 'Preparing Report...'
    };
    this.loaderService.isLoading.next(loadingObj);
    this.reportProvider.downloadReport(this.currentReport.LATEST.ID).subscribe(response => {
      if (response) {
        if (!isOrderThirdParty) {
          this.saveToFileSystem(response);
        } else {
          this.orderThirdPartyReport(response);
        }
        const loadingObj2 = {
          loading: false,
          loadingMessage: ''
        };
        this.loaderService.isLoading.next(loadingObj2);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description save report in system
   */
  private saveToFileSystem(response) {
    const blob = new Blob([response], { type: 'text/pdf' });
    const reportName = this.currentReport?.LATEST?.COMPANY?.NAME;
    saveAs(blob, reportName ? reportName + '.pdf' : 'Report.pdf');
  }

  /**
   * @description for order third party
   */
  orderThirdPartyReport(reportPDF: any = null) {

    this.reportProvider.getReportDetailsByVersionId(this.currentReport.ID, this.currentReport.LATEST.ID).subscribe(res => {
      if (res.success) {
        const currentReport = res.result;

        let reader = new FileReader();
        reader.readAsDataURL(reportPDF);
        reader.onloadend = () => {

          let orderConfirmModalRef: BsModalRef;
          orderConfirmModalRef = this.modalService.show(OrderFormConfirmPopupComponent, Object.assign({
            initialState: {
              businessName: currentReport?.LATEST?.COMPANY?.NAME || ''
            }
          }, { class: 'modal-lg modal-dialog-centered' }));
          const ackSubject = new Subject<boolean>();
          orderConfirmModalRef.content.subject = ackSubject;

          ackSubject.subscribe(result => {
            if (result) {
              let base64data = reader.result;
              let formData = Order.createFormData(currentReport, this.userService.getCurrentUser(), true);
              this.openUrlInTab(formData, environment.ORDER_FORM_URL, base64data);
            }
          });
        };

      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description open URL in new tab
   */
  private openUrlInTab(obj, url, pdf = null) {
    let mapForm = document.createElement('form');
    mapForm.target = '_blank';
    mapForm.method = 'POST';
    mapForm.action = url;

    let mapInput = document.createElement('input');
    mapInput.type = 'hidden';
    mapInput.name = 'data';
    mapInput.setAttribute('value', JSON.stringify(obj));
    mapForm.appendChild(mapInput);

    if (pdf) {
      let pdfInput = document.createElement('input');
      pdfInput.type = 'hidden';
      pdfInput.name = 'pdf';
      pdfInput.setAttribute('value', pdf);
      mapForm.appendChild(pdfInput);
    }

    document.body.appendChild(mapForm);
    mapForm.submit();
  }

  /**
   * @description for download sample PDF
   */
  downloadSample() {
    const loadingObj = {
      loading: true,
      loadingMessage: 'Preparing Report...'
    };
    this.loaderService.isLoading.next(loadingObj);
    this.reportProvider.downloadSampleReport().subscribe(res => {
      if (res) {
        this.saveToSampleReportFile(res);
      }
      const loadingObj2 = {
        loading: false,
        loadingMessage: ''
      };
      this.loaderService.isLoading.next(loadingObj2);
    }, err => {
      // Error Handling
      const loadingObj2 = {
        loading: false,
        loadingMessage: ''
      };
      this.loaderService.isLoading.next(loadingObj2);
    });
  }

  /**
   * @description save sample file in the system
   */
  private saveToSampleReportFile(response) {
    const blob = new Blob([response], { type: 'text/pdf' });
    saveAs(blob, 'Valzy - Sample Internal Business Valuation Report.pdf');
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return true;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return true;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.router.navigateByUrl(`/dashboard`);
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/risk/recurring-revenue`);
    }
  }

  /**
   * @description for lock the report
   */
  lockReport() {
    if (environment.SHOW_DEBUG) {
      this.reportProvider.lockReport(this.currentReport.ID).subscribe(resp => {
        if (resp.success) {
          this.reportService.getUpdatedStatusOfReport();
        } else {
          this.toastr.error(resp.error.txt);
        }
      }, err => {
        // Error Handling
      });
    }
  }

  /** call API to load data of preview report */
  viewReport(): void{
    const showLoading = {
      loading: true,
      loadingMessage: 'Preparing Report Preview...'
    }
    const hideLoading = {
      loading: false,
      loadingMessage: ''
    }
    this.loaderService.reportPreviewLoading.next(showLoading);
    this.reportProvider.getReportPreview(this.currentReport.LATEST.ID).subscribe(response => {
      if (response.success) {
        if(response.result?.length) {
          this.openModalOfPreviewReport(response.result);
        }
      }else{
        this.toastr.error(response.error.txt);
      }
      this.loaderService.reportPreviewLoading.next(hideLoading);
    }, err => {
      // Error Handling
      this.loaderService.reportPreviewLoading.next(hideLoading);
    });
  }

  /** Open modal to see preview of report */
  openModalOfPreviewReport(images: string[]): void{
    let copyRptModalRef: BsModalRef;
    copyRptModalRef = this.modalService.show(ViewReportModalComponent, { class: 'modal-lg modal-dialog-centered' });

    const ackSubject = new Subject<boolean>();
    copyRptModalRef.content.subject = ackSubject;
    copyRptModalRef.content.images = images;

    ackSubject.subscribe(val => {
      if (val) {
        // To do: action on ack
      }
    });
  }
}
